<template>
  <div class="appBody min-vh-100 bg-grey-light">
    <little-header></little-header>
    <no-data :text=tipTxt></no-data>
    <little-footer></little-footer>
  </div>
</template>

<script>
  import LittleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import NoData from "@/components/noData";

    export default {
      name: "noCoursePage",
      components: {
        LittleFooter,
        LittleHeader,
        NoData
      },
      props: [
        'tipTxt'
      ]
    }
</script>

<style scoped>

</style>
